// NTFSButtons.js
import { Button } from "@material-ui/core";
import { ColoredActionButton } from "../../common/buttons";

function MSADButtons({
  toggleDrawer,
  handleSaveActions,
  isEditMode,
  MSADConfigurationCheck,
}) {
  return (
    <div className="MSADButtonsContainer">
      <ColoredActionButton
        className= "cancel-button-custom-styles"
        onClick={(event) => toggleDrawer(false, event)}
      >
        Cancel
      </ColoredActionButton>
      <Button
        type="submit"
        variant="contained"
        disabled={!MSADConfigurationCheck && !isEditMode}
        color="primary"
        className="save-button-custom-styles"
        onClick={(event) => handleSaveActions(event)}
      >
        Save
      </Button>
    </div>
  );
}

export default MSADButtons;
